const OUT_OF_SCOPE_PATTERNS: RegExp[] = [
    /\bweather\b/,
    /\bnews\b/,
    /\bstock\s*market\b/,
    /\bcrypto\b/,
    /\bbitcoin\b/,
    /\bjoke\b/,
    /\brecipe\b/,
    /\bcook(ing)?\b/,
    /\btranslate\b/,
    /\bwrite\s+(?:me\s+)?(?:a\s+)?(?:poem|essay|code|script)\b/,
    /\bchatgpt\b/,
    /\bgemini\b/,
    /\bclaude\b/,
    /\bwhat\s+is\s+ai\b/,
    /\bpassword\b/,
    /\bhack\b/,
    /\bbypass\s+(?:rbac|permission|auth)/,
    /\bdelete\s+database\b/,
    /\bmigrate\b/,
    /\bcron\b/,
    /\bcompetitor\b/,
    /\bnetflix\b/,
    /\byoutube\b/,
    /\bpersonal\s+advice\b/,
    /\bmedical\b/,
    /\blegal\s+advice\b/,
];

const STUDIO_HINTS: RegExp[] = [
    /\bfilm/,
    /\bmovie/,
    /\bseries/,
    /\bview/,
    /\bwatch/,
    /\bdashboard/,
    /\breport/,
    /\bupload/,
    /\bstudio/,
    /\bwallet/,
    /\breel/,
    /\bpurchase/,
    /\bfilmmaker/,
    /\bviewer/,
    /\badmin/,
    /\bcontest/,
    /\bchallenge/,
    /\banalytics/,
    /\bsetting/,
    /\bhow\s+(?:do\s+i|to|can\s+i|upload)/,
    /\bwhere\s+(?:is|can|do)/,
    /\btop\s+\d+/,
    /\blast\s+\d+\s+days?/,
    /\bbox\s*office/,
    /\bdraft/,
    /\bapprove/,
    /\breject/,
    /\bpermission/,
    /\brbac/,
    /\bnavigate/,
    /\bpage\b/,
    /\bfield\b/,
    /\bfilter\b/,
    /\bstatus\b/,
    /\bopen\b/,
    /\bnavigate\b/,
    /\bedit\s+mode\b/,
    /\bview\s+mode\b/,
    /\bwho\s+(?:is|are|made|uploaded)\b/,
    /\bstatus\s+of\b/,
    /\bpurchases?\s+(?:of|for)\b/,
    /\bhow\s+many\s+(?:purchases?|sales|views?|minutes?|users?|films?)\b/,
    /\bwatch\s*minutes?\b/,
    /\bminutes?\s*watched\b/,
    /\bwatch\s*time\b/,
    /\btimes?\s+watched\b/,
    /\btell\s+me\s+about\b/,
    /\bmobile\b/,
    /\bphone\s*number\b/,
    /\bviewer\b/,
    /\bchannel\s*partner\b/,
    /\bcontent\s*curator\b/,
    /\brevenue\b/,
    /\bearnings\b/,
    /\bminutes?\b/,
];

/** True when text looks like Studio how-to / navigation help */
export function isHowToQuestion(text: string): boolean {
    const t = text.toLowerCase();
    return /how\s+(?:do\s+i|to|can\s+i)|where\s+(?:is|can|do)|help\s+(?:me|with)|guide\s+me|take\s+me|show\s+me\s+how|explain\s+how|steps?\s+to/.test(
        t
    );
}

export function isOutOfScope(text: string): boolean {
    const t = text.toLowerCase().trim();
    if (!t) return true;
    if (OUT_OF_SCOPE_PATTERNS.some((p) => p.test(t))) return true;

    if (/^(hi|hello|hey|help|thanks|thank you)[\s!.]*$/i.test(t)) return false;
    if (isHowToQuestion(t)) return false;

    const hasStudioHint = STUDIO_HINTS.some((p) => p.test(t));
    if (!hasStudioHint && t.split(/\s+/).length >= 4) return true;
    return false;
}

export const SLATE_REFUSE_SUGGESTIONS_ADMIN = [
    'Film views last 7 days',
    'How do I upload a film?',
    'How do I open the dashboard?',
    'List films from last 30 days',
];

export const SLATE_REFUSE_SUGGESTIONS_FILMMAKER = [
    'My film views last 7 days',
    'How do I upload a film?',
    'Show my films',
    'Where is my wallet?',
];
